<template>
  <div>
  <div class="columns">
    <div class="map">
      <gmap-map
        :center="centerReseaux"
        :zoom="zoomCartoReseaux"
        :options="mapOptions"
        class="googleMap"
        ref="map"
        @zoom_changed="updateZoom($event)" @dragend="updateMarkerVisible()" @click="close()">
        <app-info-window-map-faces v-bind:centre="center"
                                   v-bind:marker="selectedMarkerFacesDeReseaux"
                                   @closeInfoWindow="selectedMarkerFacesDeReseaux=''"/>
        <app-info-window-map-reseaux v-bind:centre="center"
                                     v-bind:marker="selectedMarkerReseaux"
                                     @closeInfoWindow="selectedMarkerReseaux=''"
                                     @zoomReseau="zoomReseau(selectedMarkerReseaux)"/>
        <gmap-marker  :key="m.num"
                      v-for="(m) in markers.data"
                      :position="m.position"
                      :clickable="m.clickable"
                      :draggable="false"
                      :icon="m.icon"
                      @click="clickMarker(m, markers.type)">
        </gmap-marker>
        <gmap-marker  :key="m.num"
                      v-for="(m) in markersFacesVisible"
                      :position="m.position"
                      :clickable="m.clickable"
                      :draggable="false"
                      :icon="m.icon"
                      @click="center=m.position, updateSelectedMarkerFaces(m),
                      isComponentDetailFacesReseauxTempo = true;">
        </gmap-marker>
        <!--gmap-marker
          key="test"
          :position="centerReseauxLc"
          :clickable="false"
          :zIndex="zIndexCenter"
          :draggable="false"
          :icon=puceNoire>
        </gmap-marker-->
        <div>
          <gmap-marker v-for="concurrent in concurrentsFiltres"
            :key="concurrent.id"
            :position="concurrent.position"
            :clickable="false"
            :draggable="false"
            :icon="concurrent.icone"
            >
          </gmap-marker>
        </div>
        <gmap-marker v-for="(point, i) in  getPointsAddress"
                     :key="i+point.libelle"
                     :position="point.coordonnees"
                     :clickable="point.clickable"
                     :draggable="false"
                     :icon="point.icon"
                     @click="center=point.coordonnees, updateSelectedMarkerReseaux(point),
                     isComponentDetailReseauxTempo = true">
        </gmap-marker>
      </gmap-map>
    </div>
    <b-modal v-model="isComponentDetailReseauxTempo"
             has-modal-card
             class="modal">
      <app-info-window-map-reseaux :centre="center"
                                   :marker="selectedMarkerReseaux"
                                   @zoomReseau="zoomReseau(selectedMarkerReseaux)"/>
    </b-modal>
    <b-modal v-model="isComponentDetailFacesReseauxTempo"
             has-modal-card
             class="modal">
      <app-info-window-map-faces :centre="center"
                                 :marker="selectedMarkerFacesDeReseaux"/>
    </b-modal>
  </div>
  <app-statistiques-geo-marketing
      :address="centerReseauxLc"
      :isochrone="isochrone"
      :typeLayerGeoMarketing="typeLayerGeoMarketing" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { setTimeout } from 'timers';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import { getMapGeoJson } from '@/api/asterop';
import { getConcurrents, overrideStyle } from '@/services/asterop/mapHelper';
import statistiquesGeoMarketing from '@/components/general/statistiquesGeoMarketing';
import { MINIMUM_CLUSTER_SIZE, TYPE_LAYER_EMPTY, MARKER_POINT_NOIR,
  TYPE_LAYER_GEO_MARKETING_CONCU, STYLE_MAPS_POI_HIDDEN,
  MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';
import InfoWindowMapFaces from '@/components/creationOpportunite/cartographie/infoWindowMapFaces';
import InfoWindowMapReseaux from './cartographie/infoWindowMapReseaux';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const User = createNamespacedHelpers('user');
const Parametrage = createNamespacedHelpers('parametrage');

export default {
  name: 'app-map',
  data() {
    return {
      center: '',
      layerGeoMarketting: false,
      concurrents: [],
      zIndexCenter: 9999,
      markersFacesParReseauxVisible: [],
      minClusterSize: MINIMUM_CLUSTER_SIZE,
      isComponentDetailReseauxTempo: false,
      isComponentDetailFacesReseauxTempo: false,
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  watch: {
    reseauxLcSelectedIndicator() {
      this.updateMarkerVisible(true);
    },
    markersFacesParReseauxLc() {
      this.updateMarkerVisible(true);
    },
    activeTabReseau() {
      if (this.activeTabReseau === 0 && this.zoomMarker) {
        this.zoomReseau(this.zoomMarker, 500);
      } else {
        this.zoomMarker = null;
      }
    },
    async isochrone() {
      await this.updateLayer();
    },
    async centerReseaux() {
      await this.updateLayer();
    },
    async typeLayerGeoMarketing() {
      await this.updateLayer();
    },
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      markersReseauxLc: 'markersReseauxLc',
      markersFacesParReseauxLc: 'markersFacesParReseauxLc',
      reseauxLcSelectedIndicator: 'reseauxLcSelectedIndicator',
      zoomCartoReseauxLc: 'zoomCartoReseauxLc',
      centerReseauxLc: 'centerReseauxLc',
      isochrone: 'isochrone',
      typeLayerGeoMarketing: 'typeLayerGeoMarketing',
      selectedMarkerFacesDeReseauxLc: 'selectedMarkerFacesDeReseauxLc',
      getSelectedMarkerReseaux: 'selectedMarkerReseauxLc',
      activeTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
      getPointsAddress: 'pointsAddress',
    }),
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    ...Parametrage.mapGetters({
      symboles: 'symboles',
    }),
    puceNoire() {
      if (Object.prototype.hasOwnProperty.call(this.centerReseauxLc, 'urlLogo')) {
        const h = 40;
        let w = h;
        const img = new Image();
        img.src = this.centerReseauxLc.urlLogo;
        if (img.height > 0) {
          w = img.width / (img.height / h);
        }
        const icon = {
          url: this.centerReseauxLc.urlLogo,
          scaledSize: { width: w, height: h, f: 'px', b: 'px' },
        };
        return icon;
      }

      if (Object.prototype.hasOwnProperty.call(this.centerReseauxLc, 'symbole') &&
          this.symboles &&
          Object.prototype.hasOwnProperty.call(this.symboles, this.centerReseauxLc.symbole)) {
        const icon = {
          url: this.symboles[this.centerReseauxLc.symbole],
          size: { width: 50, height: 50, f: 'px', b: 'px' },
          scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
        };
        return icon;
      }
      return MARKER_POINT_NOIR;
    },
    concurrentsFiltres() {
      if (Object.prototype.hasOwnProperty.call(this.centerReseauxLc, 'codeType')) {
        const tmp = this.concurrents.filter(c =>
          c.codeType === this.centerReseauxLc.codeType && c.icone);
        tmp.forEach((element) => {
          element.icone = {
            url: element.icone,
            size: { width: 20, height: 20, f: 'px', b: 'px' },
            scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
          };
        });
        return tmp;
      }
      this.concurrents.forEach((element) => {
        element.icone = {
          url: element.icone,
          size: { width: 20, height: 20, f: 'px', b: 'px' },
          scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
        };
      });
      return this.concurrents;
    },
    zoomCartoReseaux: {
      get() {
        return this.zoomCartoReseauxLc;
      },
      set(value) {
        this.setZoomCartoReseaux(value);
      },
    },
    centerReseaux: {
      get() {
        return this.centerReseauxLc;
      },
      set(value) {
        this.setCenterReseaux(value);
      },
    },
    selectedMarkerFacesDeReseaux: {
      get() {
        return this.selectedMarkerFacesDeReseauxLc;
      },
      set(value) {
        this.setSelectedMarkerFacesDeReseaux(value);
      },
    },
    selectedMarkerReseaux: {
      get() {
        return this.getSelectedMarkerReseaux;
      },
      set(value) {
        this.setSelectedMarkerReseaux(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    markers() {
      if (this.zoomCartoReseaux >= 12) {
        return {
          type: 'Faces',
          data: this.markersFacesParReseauxLc,
        };
      }
      return {
        type: 'Reseaux',
        data: this.markersReseauxLc,
      };
    },
    markersFacesVisible() {
      if (this.zoomCartoReseaux >= 12) {
        return this.markersFacesParReseauxVisible;
      }
      return [];
    },
  },
  methods: {
    ...VenteReseauxLc.mapMutations({
      setZoomCartoReseaux: types.SET_ZOOM_CARTO_RESEAUX,
      setCenterReseaux: types.SET_CENTER_RESEAUX,
      setSelectedMarkerFacesDeReseaux: types.SET_SELECTED_MARKER_FACES_DE_RESEAUX,
      setSelectedMarkerReseaux: types.SET_SELECTED_MARKER_RESEAUX,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...Parametrage.mapActions({
      actionsLoadSymboles: 'loadSymboles',
    }),
    async updateLayer() {
      // Largement inspiré de
      // https://stackoverflow.com/questions/50496101/remove-google-map-geojson-polygon
      // https://developers.google.com/maps/documentation/javascript/datalayer
      const map = await this.$refs.map.$mapPromise;
      this.concurrents = [];
      if (this.layerGeoMarketting && this.layerGeoMarketting.setMap) {
        this.layerGeoMarketting.setMap(null);
      }
      if (!this.centerReseauxLc ||
          !this.hasGeoMarketing ||
          this.typeLayerGeoMarketing === TYPE_LAYER_EMPTY) {
        return;
      }
      this.layerGeoMarketting = new google.maps.Data({
        map: map,
      });

      const response = await getMapGeoJson(this.typeLayerGeoMarketing, this.centerReseauxLc,
        this.isochrone);
      if (this.typeLayerGeoMarketing === TYPE_LAYER_GEO_MARKETING_CONCU) {
        this.concurrents = await getConcurrents(this.centerReseauxLc,
          this.isochrone, 1, this.symboles);
      }
      const geoJson = response.data;
      const styles = geoJson.style;

      this.layerGeoMarketting.addGeoJson(geoJson);
      this.layerGeoMarketting.setStyle((feature) => {
        return overrideStyle(feature, styles);
      });
    },
    updateZoom($event) {
      this.zoomCartoReseaux = $event;
      this.selectedMarkerFacesDeReseaux = '';
      this.selectedMarkerReseaux = '';
      this.updateMarkerVisible();
    },
    updateMarkerVisible(force) {
      if (this.zoomCartoReseaux < 12) {
        this.markersFacesParReseauxVisible = [];
        return;
      }
      if (force) {
        this.markersFacesParReseauxVisible = [];
      }
      const bounds = this.$refs.map.$mapObject.getBounds();
      this.markersFacesParReseauxLc.forEach(m => {
        if (bounds.contains(m.position) && !this.markersFacesParReseauxVisible.includes(m)) {
          this.markersFacesParReseauxVisible.push(m);
        }
        this.markersFacesParReseauxVisible.forEach((marker) => {
          if (!bounds.contains(marker.position)) {
            this.markersFacesParReseauxVisible.splice(
              this.markersFacesParReseauxVisible.indexOf(marker), 1);
          }
        });
      });
    },
    updateSelectedMarkerReseaux(marker) {
      this.selectedMarkerReseaux = marker;
    },
    updateSelectedMarkerFaces(marker) {
      this.selectedMarkerFacesDeReseaux = marker;
    },
    close() {
      if (this.selectedMarkerReseaux) {
        this.selectedMarkerReseaux = '';
      }
      if (this.selectedMarkerFacesDeReseaux) {
        this.selectedMarkerFacesDeReseaux = '';
      }
    },
    zoomReseau(marker) {
      new Promise(resolve => {
        this.centerReseaux = marker.position;
        setTimeout(resolve, 0);
      }).then(() => {
        this.zoomCartoReseaux = 12;
        this.updateMarkerVisible();
      });
    },
    async autoZoom() {
      if (this.$refs.map === undefined) return;
      await this.$refs.map.$mapPromise;
      this.fitBounds();
    },
    fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      if (this.markersFacesParReseauxVisible.length) {
        this.markersFacesParReseauxVisible.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.markersReseauxLc.length) {
        this.markersReseauxLc.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.concurrentsFiltres.length) {
        this.concurrentsFiltres.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.getPointsAddress.length) {
        this.getPointsAddress.forEach(marker => {
          latlngbounds.extend(marker.coordonnees);
        });
      }
      latlngbounds.extend(this.centerReseaux);
      this.$refs.map.fitBounds(latlngbounds);
    },
    clickMarker(marker, type) {
      if (type === 'Faces') {
        this.center = marker.position;
        this.updateSelectedMarkerFaces(marker);
        this.isComponentDetailFacesReseauxTempo = true;
      }
      if (type === 'Reseaux') {
        this.center = marker.position;
        this.updateSelectedMarkerReseaux(marker);
        this.isComponentDetailReseauxTempo = true;
      }
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
  },
  async mounted() {
    await this.autoZoom();
    await this.initPoi();
    if (this.hasGeoMarketing) {
      await this.updateLayer();
      await this.actionsLoadSymboles();
    }
  },
  components: {
    appInfoWindowMapFaces: InfoWindowMapFaces,
    appInfoWindowMapReseaux: InfoWindowMapReseaux,
    appStatistiquesGeoMarketing: statistiquesGeoMarketing,
  },
};

</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/recherche/carte.vue